export const SsoLogoutPageDisplayTextEs = {
    alertStaticText: 'Has cerrado sesión en My Lincoln Portal',
    bodySection1: `Para iniciar sesión nuevamente en My Lincoln Portal, visite el sitio interno de su empresa`,
};
